// const slides = {
//   dataSlider: [
//     {
//       id: 1,
//       url_target: 'https://ziswaf.masjed.id/campaign/34',
//       url_image: '/img/sliders/update/01.png',
//     },
//     {
//       id: 2,
//       url_target: 'https://masjed.id/download-sekarang',
//       url_image: '/img/sliders/update/02.png',
//     },
//     {
//       id: 3,
//       url_target:
//         'https://ziswaf.masjed.id/transaction/create/78?name=&email=&telp=&inapp=1&mirror=1',
//       url_image: '/img/sliders/update/03.png',
//     },
//     {
//       id: 4,
//       url_target:
//         'https://ziswaf.masjed.id/transaction/create/17?lembaga=masjed',
//       url_image: '/img/sliders/update/04.png',
//     },
//     {
//       id: 5,
//       url_target:
//         'https://www.youtube.com/channel/UCD0n5V7JEWlLk2MAS79KNEg',
//       url_image: '/img/sliders/update/05.png',
//     },
//     {
//       id: 6,
//       url_target:
//         'https://ziswaf.masjed.id/transaction/create/11?lembaga=masjed',
//       url_image: '/img/sliders/update/06.png',
//     },
//     {
//       id: 7,
//       url_target: 'https://ziswaf.masjed.id/transaction/create/62',
//       url_image: '/img/sliders/update/07.png',
//     },
//     {
//       id: 8,
//       url_target: 'https://ziswaf.masjed.id/transaction/create/56',
//       url_image: '/img/sliders/update/08.png',
//     },
//   ],
// };

const slides = {
  dataSlider: [
    {
      id: 1,
      url_target:
        'https://ziswaf.masjed.id/campaign/17?lembaga=masjed',
      url_image: '/img/sliders/ramadhan2023/01.png',
    },
    {
      id: 2,
      url_target:
        'https://ziswaf.masjed.id/campaign/36?lembaga=masjed',
      url_image: '/img/sliders/ramadhan2023/02.png',
    },
    {
      id: 3,
      url_target:
        'https://ziswaf.masjed.id/campaign/13?lembaga=masjed',
      url_image: '/img/sliders/ramadhan2023/03.png',
    },
    {
      id: 4,
      url_target:
        'https://ziswaf.masjed.id/campaign/35?lembaga=masjed',
      url_image: '/img/sliders/ramadhan2023/04.png',
    },
    {
      id: 5,
      url_target:
        'https://ziswaf.masjed.id/campaign/29?lembaga=masjed',
      url_image: '/img/sliders/ramadhan2023/05.png',
    },
    {
      id: 6,
      url_target:
        'https://ziswaf.masjed.id/campaign/120?lembaga=ydym',
      url_image: '/img/sliders/ramadhan2023/06.png',
    },
    {
      id: 7,
      url_target:
        'https://ziswaf.masjed.id/campaign/124?lembaga=ydym',
      url_image: '/img/sliders/ramadhan2023/07.png',
    },
  ],
};

export default {
  ...slides,
};
